// Rotating search
document.addEventListener("DOMContentLoaded", () => {

  const input = document.getElementById("rotating-placeholder");

  const placeholders = [
    "Straws...",
    "plates...",
    "bowls...",
    "cups...",
    "containers...",
    "product or SKU code..."
  ];

  const baseText = "Search ";

  let currentPhrase = 0;
  let currentLetter = 0;
  let isDeleting = false;

  function typeEffect() {
    const currentText = placeholders[currentPhrase];

    const fullText = baseText + currentText;

    if (!isDeleting) {
      input.setAttribute(
        "placeholder",
        baseText + currentText.substring(0, currentLetter + 1)
      );
      currentLetter++;

      if (currentLetter === currentText.length) {
        isDeleting = true;
        setTimeout(typeEffect, 1500);
        return;
      }

    } else {
      input.setAttribute(
        "placeholder",
        baseText + currentText.substring(0, currentLetter - 1)
      );
      currentLetter--;

      if (currentLetter === 0) {
        isDeleting = false;
        currentPhrase = (currentPhrase + 1) % placeholders.length;
      }
    }

    setTimeout(typeEffect, isDeleting ? 40 : 80);
  }

  typeEffect();
});
// collapsible footer
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 989) {

    document.querySelectorAll(".footer-toggle").forEach(function (toggle) {
      toggle.addEventListener("click", function () {
        const parent = this.closest(".links-footer, .content-footer");
        parent.classList.toggle("active");
      });
    });

  }
});

document.querySelectorAll('.first-level-dropdown').forEach(function(li){

    const observer = new MutationObserver(function(){

        const icon = li.querySelector('.dropdown-icon i');

        if(!icon) return;

        if(li.classList.contains('nav-hover')){
            icon.classList.remove('fa-caret-up');
            icon.classList.add('fa-caret-down');
        }else{
            icon.classList.remove('fa-caret-down');
            icon.classList.add('fa-caret-up');
        }

    });

    observer.observe(li,{
        attributes:true,
        attributeFilter:['class']
    });

});

